import {
  ERROR_NOTIFICATION_SETTINGS,
  SAVING_NOTIFICATION_SETTINGS,
  SET_SHOW_BLOCKED_NOTIFICATIONS_MODAL,
  SUCCESS_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS,
} from '../constants/actions';

export const setShowBlockedNotificationsModal = showBlockedBanner => {
  return {
    type: SET_SHOW_BLOCKED_NOTIFICATIONS_MODAL,
    showBlockedBanner,
  };
};

export const updateNotificationSettings = notificationSettings => {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS,
    notificationSettings,
  };
};

export const savingNotificationSettings = notificationSettings => {
  return {
    type: SAVING_NOTIFICATION_SETTINGS,
    notificationSettings,
  };
};

export const successNotificationSettings = response => {
  return {
    type: SUCCESS_NOTIFICATION_SETTINGS,
    response,
  };
};

export const errorNotificationSettings = errorMessage => {
  return {
    type: ERROR_NOTIFICATION_SETTINGS,
    errorMessage,
  };
};
